import { render } from "./student-change-password.vue?vue&type=template&id=3f85c1b5"
import script from "./student-change-password.vue?vue&type=script&lang=js"
export * from "./student-change-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__